<div class="bcg" >
  <div class="d-flex justify-content-between custom-container mt-3">
    <nav class="custom-nav">
      <ol class="breadcrumb m-2">
        <li class="breadcrumb-item"  style="cursor: pointer;" (click)="back()">Dashboard</li>
        <li class="breadcrumb-item active" style="cursor: context-menu;" aria-current="page">User Management</li>
      </ol>
    </nav>
    <div class="dropdown-container">
      <app-dropdown
        [options]="cities"
        [(ngModel)]="selectedCity"
        placeholder="All branches"
        optionLabel="name"
        [showClear]="true"
        [style]="{width: '240px',height: '32px',display: 'flex','align-items': 'center','border-radius':'10px','z-index':'1'}"></app-dropdown>
    </div>
  </div>
  <div class="page_responsive card mt-3">
    <div class="card-body">
      <div class="row">
        <span class="col-6 card-title title_header">User Management</span>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <p style="margin-top: 25px; font-size: 13px;">
            Add new users and manage your existing users here!
          </p>
        </div>

        <div>
          <button
            class="button-style"
            (click)="savePersonalDetails()"
            type="button">
            <i class="bx bx-plus-circle" style="position: absolute; margin-top:2px;font-size: 1.1rem !important;"></i>
            <span style="padding-left: 24px;" [routerLink]="'/doqfy/userManagement/add-user'"> Add New User </span>
          </button>

       
        </div>
      </div>
    </div>
  </div>

  <div class="page_responsive card mt-3">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="col">
          <span class="col-6 card-title title_header">User Details</span>
        </div>
        <div class="d-flex justify-content-between">
          <div class="col">
            <app-search-input placeholder="Search user"></app-search-input>
          </div>
          <div>
            <button
              class="button-style-export"
              (click)="savePersonalDetails()"
              type="button">
                <i class="bx bx-download" style="position: absolute; margin-top:2px;font-size: 1.1rem !important;"></i>
              <span style="padding-left: 28px;"> Export Excel</span>
            </button>
         </div>
          <div>
            <app-column-chooser [table]="dataTable"></app-column-chooser>
          </div>
        </div>
      </div>

      <div style="border: 1px solid #E8ECF3;
      border-radius: 10px; " class="mt-4">
        <app-data-table
          #dataTable
          [columnChooser]="true"
          [columns]="userColumns"
          [data]="Users"
          [totalRecords]="totalRecords"
          [rows]="1"
          [paginator]="true"
          (pageChange)="onPageChange($event)">
          <ng-template appTableCell="si_no" let-row>1.</ng-template>
          <ng-template appTableCell="name" let-row>Jabastin</ng-template>
          <ng-template appTableCell="role" let-row>Branch Admin</ng-template>
          <ng-template appTableCell="email" let-row>abc&#64;gmail.com</ng-template>
          <ng-template appTableCell="mobile" let-row>1234567890</ng-template>
          <ng-template appTableCell="created_on" let-row>05 May 2023</ng-template>

          <ng-template appTableCell="status" let-row>
            <label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="isActive" />
              <span class="slider"></span>
              <span class="switch-text">{{
                isActive ? "Inactive" : "Active"
              }}</span>
            </label>
          </ng-template>

          <ng-template appTableCell="action" let-row>
            <div>
              <i
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                class="bx bx-trash-alt"
              ></i>
              <i
                class="bx bx-edit"
                [routerLink]="'/doqfy/userManagement-editor/form'"
              ></i>
            </div>
          </ng-template>
        </app-data-table>
      </div>
      <!-- <div class="users">
        <p >Total no. of Users: </p>
      </div> -->
<!-- <div style="display: flex; justify-content: flex-end;">
      <p-paginator   [rows]="10" [totalRecords]="120"  [rowsPerPageOptions]="[10,20,30]"></p-paginator>
    </div> -->
    </div>


   
  </div>
</div>



<div class="toast_display_layer">
  <p-toast></p-toast>
 </div>

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <h5 class="modal-title mt-4" id="exampleModalLabel">
          Are you sure you want to delete?
        </h5>
      </div>
      <div class="d-flex justify-content-center mb-5">
        <button
          type="button"
         
          data-bs-dismiss="modal"
          class="btn btn-outline-custom me-4"
        > <!-- (click)="showError()"-->
          Cancel
        </button>
        <button
type="button"
          (click)="showSuccess()"
          data-bs-dismiss="modal"
          class="btn btn-outline-custom1"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
